import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { AppState } from 'services/types';
import { VarietyShortName, VarietiesProps } from 'services/varieties/types';
import { makeSelectVarietyShortName } from 'services/varieties/selectors';

type OwnProps = VarietiesProps;

interface ConnectedProps {
    shortName?: VarietyShortName;
}

type Props = OwnProps & ConnectedProps;

export class VarietyShortNameValueComponent extends React.PureComponent<Props> {
    render(): VarietyShortName | null {
        const { shortName } = this.props;

        if (!shortName) {
            return null;
        }

        return shortName;
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    shortName: makeSelectVarietyShortName()
});

export default connect(mapStateToProps)(VarietyShortNameValueComponent);
